import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {

  @Output() clickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    // this condition is added to check if the click is inside the overlay component,
    // for example if we have dropdown inside the overlay, on seleect of dropdown, overlay is closed.
    const isOverlayClick = target.closest('.cdk-overlay-pane');
    if (!clickedInside && target.innerHTML != 'expand_more' && !isOverlayClick) {
      console.log('outside click xx');
      this.clickOutside.emit();
    }
  }

}